export default {
  path: 'customer-management',
  name: '客户管理',
  icon: 'CustomFilled',
  accessKey: '/customer-management',
  routes: [
    { path: '', redirect: 'employment' },
    {
      path: 'employment',
      component: '@/pages/customer-management',
      name: '用工客户',
      accessKey: '/customer-management',
    },
    {
      path: 'labor',
      component: '@/pages/customer-management/labor-customer',
      name: '劳务客户',
      accessKey: '/customer-management',
    },
  ],
};
